
// Rates & History - Equipment Analtics

import React, {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import Loading from "../components/Loading";
import {useAuth0, withAuthenticationRequired} from "@auth0/auth0-react";
import UserService from "../services/UserService";
import DataTable from "react-data-table-component";
import {CSVLink} from "react-csv";
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-data-grid/lib/styles.css';
import {customStyles} from "../pages/Constants";
import '../styles/components/daily-lane-analytics.css';

export const DailyLaneDataAnalytics = () => {

    const columns = [
        {
            name: 'Equipment',
            selector: row => row.equipment,
            sortable: true,
            cell: row => <div className="table-cell-text">{row.equipment}</div>
        },
        {
            name: 'Drop Date',
            selector: row => row.dropDate,
            sortable: true,
            cell: row => <div className="table-cell-text">{row.dropDate}</div>
        },
        {
            name: 'Total Miles',
            selector: row => row.totalMiles,
            sortable: true,
            cell: row => <div className="table-cell-text">{row.totalMiles}</div>
        },
        {
            name: 'Loads',
            selector: row => row.loads,
            sortable: true,
            cell: row => <div className="table-cell-text">{row.loads}</div>
        },
        {
            name: 'LANE RATE PER MILE ',
            selector: row => row.averagePricePerMile,
            sortable: true,
            cell: row => <div className="table-cell-text">${row.averagePricePerMile}</div>
        }
    ];

    const { register, handleSubmit, reset } = useForm();
    const financial = (x) => Number.parseFloat(x).toFixed(2);
    
    // user state for form
    const [farelanesUser, setFarelanesUser] = useState(null);

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    const [equipmentValue, setEquipmentValue] = useState([
        {value: 'apex', label: 'Apex'},
        {value: 'integra', label: 'Integra'},
        {value: 'FactorGenie', label: 'FactorGenie'}
    ]);
    const [equipmentOptions, setEquipmentOptions] = useState({value: 'apex', label: 'Apex'});

    function handleEquipmentChange(value) {
        setEquipmentOptions(value);
    }

    async function handleSearch() {
        const token = await getAccessTokenSilently();

        let text = ''
        for (let i = 0; i < equipmentValue.length; i++) {
            text += equipmentValue[i].value + ",";
        }

        setState({
            message: "loading..",
            loading: true,
            data: []
        });

        UserService.laneAnalytics(startDate.getTime(), endDate.getTime(), token).then(
            response => {
                setData(response.data);
                setList(response.data.data);
                setState({
                    loading: false,
                    message: 'Success!'
                });
            },
            error => {
                if (error.response && error.response.status === 401) {
                }
            }
        );
    }

    const [data, setData] = useState(null);
    const [list, setList] = useState(null);
    const [state, setState] = useState({
        showResult: false,
        apiMessage: 'Tickers are loading ....',
        error: null,
        content: '',
        message: '',
    });

    const {
        getAccessTokenSilently,
        user
    } = useAuth0();

    const callApi = async () => {
        try {
            const token = await getAccessTokenSilently();
            UserService.me(token, user).then(
                response => {
                    setState({
                        ...state,
                        showResult: true,
                        apiMessage: response.data
                    });
                    setFarelanesUser({ firstName: response.data.auth0GivenName, lastName: response.data.auth0FamilyName })
                }
            );
        } catch (error) {
            setState({
                ...state,
                error: error.error,
            });
        }
    }

    // effect runs on component mount
    useEffect(() => {
        callApi().then();
    }, []);

    // effect runs when user state is updated
    useEffect(() => {
        reset(farelanesUser);
    }, [farelanesUser]);

    function onSubmit(data) {
        return false;
    }

    return (
        <div className="daily-lane-analytics">
        	
        	
            <div className="control-section">
                <div className="date-inputs">
                    <div className="filter-group flex-0">
						<label className="filter-label pick">DROP DATE (START)</label>
                        <DatePicker 
                            className="date-picker start-date-picker"
                            value={startDate} 
                            onChange={(date) => setStartDate(date)}
                            minDate={new Date("02-01-2024")}
                        />
                    </div>
                    
                    <div className="filter-group flex-0">
						<label className="filter-label drop">DROP DATE (END)</label>
                        <DatePicker 
                            className="date-picker end-date-picker"
                            value={endDate} 
                            onChange={(date) => setEndDate(date)}
                        />
                    </div>
                </div>

                <div className="query-section">

                	<div>
                		
                		{data && data.quotaMessage && (
                        	<div className="query-quota">
                        	    Your Quota: {data.quotaMessage}
                        	</div>
                    	)}
                		
                		<div>
                			<button
                        		className="query-button"
                        		onClick={handleSearch}
                        		disabled={state.loading}
                    			>
                        		{/*{state.loading && (
                            		<span className="spinner-border spinner-border-sm me-2"></span>
                        		)}*/}
                        		{state.loading ? (
									<span className="spinner-border spinner-border-sm"></span>
                               	) : (
                                	<span>QUERY</span>
                                )}                   
                    		</button>
                		</div>

                	</div>
                    
                </div>

            </div>

            {data && data.quotaFull && (
                <div className="error-message">
                    {data.quotaMessage} Your monthly search quota has expired! Please try again later.
                </div>
            )}

            {list && list.length > 0 && (
                <div className="results-section">
                    <div className="data-table-container equipment-analytics-table">
                        <DataTable
                            customStyles={{
                                table: {
                                    style: {
                                        backgroundColor: 'transparent',
                                    },
                                },
                            }}
                            striped={true}
                            columns={columns}
                            data={list}
                            defaultSortAsc={false}
                            direction="auto"
                            fixedHeaderScrollHeight="300px"
                            pagination
                            responsive
                            subHeaderAlign="right"
                            subHeaderWrap
                        />
                    </div>
                    
                    {data && data.length > 0 && (
                        <div className="export-section">
                            <CSVLink data={data} filename={"equipment-analytics.csv"}>
                                <span className="export-button">Export</span>
                            </CSVLink>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default withAuthenticationRequired(DailyLaneDataAnalytics, {
    onRedirecting: () => <Loading />,
});
